module.exports = __webpack_public_path__ + "static/media/business_verification2.83483cfb.png";